import Loader from "react-loaders";
import { NavLink } from "react-router-dom";
import "./index.scss";
const Footer = () => {
  return (
    <footer className="fixed-bottom">
      <div className="footer-logos">
        <a href="https://www.instagram.com/bigbee.eg/">
          <i className="fa-brands fa-instagram fa-2x"></i>
        </a>

        <a href="https://www.linkedin.com/company/bigbee-eg/">
          <i className="fa-brands fa-linkedin-in fa-2x"></i>
        </a>
        <a href="https://www.facebook.com/people/BigBee-EG/100087466396467/">
          <i className="fa-brands fa-facebook fa-2x"></i>
        </a>
      </div>
      <span>
        © 2026 BigBee Marketing — A brand of Big B for Digital Marketing and Events. Registered in
        Egypt.
      </span>{' '}
      <span>© 2026 بيج بي للتسويق الرقمي وإقامة الحفلات. مسجلة في مصر.</span>{' '}
    </footer>
  );
};

export default Footer;
